// 子仓库-工具管理
import to from 'await-to-js';
import * as apis from "@/api/interface/tool";

export default {
  namespaced: true,
  state: () => ({
    aiAudioValidateList: undefined, //AI音频验证 - 列表
    acmCallList: undefined, //标记台 - 通话标记 - 列表
    acmOverview: undefined, //标记台 - 对话标记 - 获取通话标记概览
    acmDetail: undefined, //标记台 - 对话标记 - 获取通话标记详情
    amcrList: undefined, //标记通话记录 - 列表
    acmlCallList: undefined, //观察台 - 通话标记 - 列表
    acmlList: undefined, //观察台 - 对话标记 - 列表
    audioList: undefined, //多条件音频 - 列表
    intentionStats: undefined, //意图判断准确率 - 统计
    asrStats: undefined, //语音转文字准确率 - 统计
    aiCallTestRecordList: undefined, //测试台 - 通话测试记录 - 列表
    avmsIntentionMarkResult: undefined, //数据统计 - 标记分析 - 统计
    avmsFeedbackList: undefined, //数据统计 - 优化反馈 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // AI音频验证 - 列表
    async getAiAudioValidateList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiAudioValidateList(payload));
      ctx.commit("update", {
        aiAudioValidateList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // AI音频验证 - 保存
    async aiAudioValidateUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.aiAudioValidateUpdate(payload));
      return res;
    },
    // AI音频验证 - select
    async aiAudioValidateSelect(ctx, payload = {}) {
      const [, res] = await to(apis.aiAudioValidateSelect(payload));
      return res;
    },



    // 剧本ID - 选项
    async getLinkScriptOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getLinkScriptOptions(payload));
      return res;
    },
    // 剧本节点 - 选项
    async getLinkScriptNodeOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getLinkScriptNodeOptions(payload));
      return res;
    },
    // 命中策略选择 - 选项
    async getStrateOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getStrateOptions(payload));
      return res;
    },
    // 对话节点 - 选项
    async getConversationNodeOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getConversationNodeOptions(payload));
      return res;
    },
    // 标记师 - 选项列表
    async getMarkUserOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getMarkUserOptions(payload));
      return res;
    },
    // 标记师 - 选项列表(新接口，带userId)
    async getNewMarkUserOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getNewMarkUserOptions(payload));
      return res;
    },



    // 录音下发数量查询 
    async voiceAssignCountQuery(_ctx, payload = {}) {
      const [, res] = await to (apis.voiceAssignCountQuery(payload));
      return res;
    },
    // 录音下发
    async voiceAssign(_ctx, payload = {}) {
      const [, res] = await to (apis.voiceAssign(payload));
      return res;
    },



    // 标记台 - 通话标记 - 列表
    async getAcmCallList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAcmCallList(payload));
      ctx.commit("update", {
        acmCallList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 标记台 - 通话标记 - 详情
    async getAcmCallDetail(ctx, payload = {}) {
      const [, res] = await to (apis.getAcmCallDetail(payload));
      return res;
    },
    // 标记台 - 通话标记 - 意图标记
    async acmCallChatIntentionMark(_ctx, payload = {}) {
      const [, res] = await to (apis.acmCallChatIntentionMark(payload));
      return res;
    },
    // 标记台 - 通话标记 - 更新
    async acmCallUpdate(_ctx, payload = {}) {
      const [, res] = await to (apis.acmCallUpdate(payload));
      return res;
    },

    // 标记台 - 对话标记 - 获取通话标记概览
    async getAcmOverview(ctx, payload = {}) {
      const [err, res] = await to (apis.getAcmOverview(payload));
      ctx.commit("update", {
        acmOverview: !err && res.data ? res.data : undefined,
      });
    },
    // 标记台 - 对话标记 - 获取通话标记详情
    async getAcmDetail(ctx, payload = {}) {
      const [err, res] = await to (apis.getAcmDetail(payload));
      ctx.commit("update", {
        acmDetail: !err && res.data ? res.data : undefined,
      });
    },
    // 标记台 - 对话标记 - 标记提交
    async acmSubmit(_, payload = {}) {
      const [, res] = await to(apis.acmSubmit(payload));
      return res;
    },




    // 标记通话记录 - 列表
    async getAmcrList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAmcrList(payload));
      ctx.commit("update", {
        amcrList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 标记通话记录 - 导出
    async amcrExport(_, payload = {}) {
      const [, res] = await to(apis.amcrExport(payload));
      return res;
    },
    // 标记通话记录 - 触发实时ASR识别（异步）
    async asrRecognize(_, payload = {}) {
      const [, res] = await to(apis.asrRecognize(payload));
      return res;
    },
    // 标记通话记录 - 查询实时ASR识别结果（轮询）
    async getAsrResult(_, payload = {}) {
      const [, res] = await to(apis.getAsrResult(payload));
      return res;
    },



    // 观察台 - 通话标记 - 列表
    async getAcmlCallList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAcmlCallList(payload));
      ctx.commit("update", {
        acmlCallList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 观察台 - 通话标记 - 导出
    async acmlCallExport(_, payload = {}) {
      const [, res] = await to(apis.acmlCallExport(payload));
      return res;
    },
    



    // 观察台 - 对话标记 - 列表
    async getAcmlList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAcmlList(payload));
      ctx.commit("update", {
        acmlList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 观察台 - 对话标记 - 导出
    async acmlExport(_, payload = {}) {
      const [, res] = await to(apis.acmlExport(payload));
      return res;
    },



    // FAQ维护台 - 上传
    async faqUpload(_, payload = {}) {
      const [, res] = await to(apis.faqUpload(payload));
      return res;
    },



    // 多条件查询音频列表
    async getAudioList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAudioList(payload));
      ctx.commit("update", {
        audioList: !err && res.data ? res.data : undefined,
      });
      return res;
    },



    // 测试台 - 通话测试 - AI通话启动
    async startAiCallTest(_, payload = {}) {
      const [, res] = await to(apis.startAiCallTest(payload));
      return res;
    },
    // 测试台 - 通话测试 - AI通话启动状态查询
    async queryAiCallTestStatus(_, payload = {}) {
      const [, res] = await to(apis.queryAiCallTestStatus(payload));
      return res;
    },
    // 测试台 - 通话测试 - 详情
    async getAiTestCallDetail(_, payload = {}) {
      const [, res] = await to(apis.getAiTestCallDetail(payload));
      return res;
    },
    // 测试台 - 通话测试记录 - 列表
    async getAiCallTestRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAiCallTestRecordList(payload));
      ctx.commit("update", {
        aiCallTestRecordList: !err && res.data ? res.data : undefined,
      });
      return res;
    },



    // 测试台 - 测试提交
    async aiTestSubmit(_, payload = {}) {
      const [, res] = await to(apis.aiTestSubmit(payload));
      return res;
    },
    // 测试台 - 测试结果下载
    async aiTestResultExport(_, payload = {}) {
      const [, res] = await to(apis.aiTestResultExport(payload));
      return res;
    },



    // 策略迭代 - 列表
    async getAsiList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAsiList(payload));
      ctx.commit("update", {
        asiList: !err && res.data ? res.data : undefined,
      });
    },


    // 数据统计 - 标记分析 - 统计
    async getAvmsIntentionMarkResult(ctx, payload = {}) {
      const [err, res] = await to (apis.getAvmsIntentionMarkResult(payload));
      ctx.commit("update", {
        avmsIntentionMarkResult: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 意图判断准确率 - 统计
    async getIntentionStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getIntentionStats(payload));
      ctx.commit("update", {
        intentionStats: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 语音转文字准确率 - 统计
    async getAsrStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getIntentionStats(payload));
      ctx.commit("update", {
        asrStats: !err && res.data ? res.data : undefined,
      });
      return res;
    },


    // 数据统计 - 优化反馈 - 筛选项
    async getAvmsFeedbackFilterOptions(_ctx, payload = {}) {
      const [, res] = await to(apis.getAvmsFeedbackFilterOptions(payload));
      return res;
    },
    // 数据统计 - 优化反馈 - 列表
    async getAvmsFeedbackList(ctx, payload = {}) {
      const [err, res] = await to(apis.getAvmsFeedbackList(payload));
      ctx.commit("update", {
        avmsFeedbackList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 数据统计 - 优化反馈 - 下载当前页
    async exportAvmsFeedbackList(_ctx, payload = {}) {
      const [, res] = await to(apis.exportAvmsFeedbackList(payload));
      return res;
    },



    

  },
  modules: {},
};
